// src/i18n/IntlProviderWrapper.jsx

import { IntlProvider } from "react-intl";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import en from "./en.json";
import pt from "./pt.json";
import es from "./es.json";
// import Loading from "../components/Loading"; // Removido, pois não é mais retornado diretamente

const messagesMap = { en, pt, es };
const supportedLocales = ["en", "pt", "es"];

const getLangFromURL = (search) => {
  const params = new URLSearchParams(search);
  const lang = params.get("lang");
  return supportedLocales.includes(lang) ? lang : "en";
};

export default function IntlProviderWrapper({ children }) {
  const location = useLocation();
  // Calcula o estado inicial diretamente para garantir que 'messages' nunca seja null
  const initialLang = getLangFromURL(location.search);
  const [locale, setLocale] = useState(initialLang);
  const [messages, setMessages] = useState(messagesMap[initialLang] || {}); // Inicializa com um objeto

  useEffect(() => {
    const lang = getLangFromURL(location.search);
    if (lang !== locale) { // Atualiza apenas se o idioma da URL realmente mudou
      setLocale(lang);
      setMessages(messagesMap[lang] || {});
    }
  }, [location.search, locale]); // 'locale' é uma dependência para reagir a mudanças externas no 'locale', se houver

  return (
    <IntlProvider locale={locale} messages={messages} key={locale}>
      {children}
    </IntlProvider>
  );
}
